/* eslint-disable no-unused-vars */
import React from 'react';
import style from './existingItem.module.scss';
import Indicator from 'components/adminList/components/indicator/indicator';
import UserData from 'components/adminList/components/userData/userData';
import Select from '@mui/material/Select';
import DeleteIcon from 'icons/delete';

export default function RequestItem() {
  return (
    <div className={'adminListItem'}>
      <Indicator bgColor="#DDDDDD"></Indicator>
      <UserData></UserData>
      <div className={'vertical'}></div>

      <Select
        className={style.select}
        variant="filled"
        disableUnderline={true}
      ></Select>

      <div className={'vertical'}></div>
      <DeleteIcon className={style.delete}></DeleteIcon>
    </div>
  );
}
